// src/components/ui/EmptyState.jsx
import React from "react";
import { Button } from "reactstrap";

/**
 * Generic EmptyState block
 * Props:
 * - title: string
 * - hint: string
 * - icon: className for your icon font (e.g., "tim-icons icon-simple-add")
 * - ctaLabel: string (button text)
 * - onCta: function
 * - rightSlot: ReactNode (optional right side custom content instead of CTA)
 * - className: string (optional)
 */
export const EmptyState = ({
  title = "Nothing here yet",
  hint = "When you add items, they'll appear here.",
  icon = "tim-icons icon-components",
  ctaLabel = "Add",
  onCta,
  rightSlot,
  className = "",
}) => {
  return (
    <div
      className={`empty-state d-flex align-items-center justify-content-between ${className}`}
      style={{
        padding: "20px 12px",
        borderBottom: "none",
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: "16px" }}>
        <div
          className="icon d-inline-flex align-items-center justify-content-center"
          style={{
            width: 42,
            height: 42,
            borderRadius: 10,
            background: "rgba(255,255,255,0.06)",
          }}
        >
          <i className={icon} style={{ fontSize: 18 }} />
        </div>
        <div>
          <h6 className="mb-1" style={{ fontWeight: 600 }}>
            {title}
          </h6>
          <p className="mb-0" style={{ opacity: 0.75 }}>
            {hint}
          </p>
        </div>
      </div>

      <div>
        {rightSlot ? (
          rightSlot
        ) : (
          <Button color="primary" size="sm" onClick={onCta} disabled={!onCta}>
            {ctaLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
